import React from 'react';
// import Navbar from './Navbar';
import Header from './Header';
// import Particles from './Particles';

const Home = () => {
    return (
        <>
            {/* <Navbar/> */}
            <Header />
            {/* <Particles/> */}
        </>
    )
}

export default Home
